export const CLOSE_MODAL = 'CLOSE_MODAL';
export const CONNECTION_LOST = 'CONNECTION_LOST';
export const CURRENT_SUBSCRIPTION_RECEIVE = 'CURRENT_SUBSCRIPTION_RECEIVE';
export const CONNECTION_RESTORED = 'CONNECTION_RESTORED';
export const CURRENT_USER_RECEIVE = 'CURRENT_USER_RECEIVE';
export const DOCUMENT_HEAD_TITLE_SET = 'DOCUMENT_HEAD_TITLE_SET';
export const LOGIN_AUTH_VERIFY_USER_REQUEST = 'LOGIN_AUTH_VERIFY_USER_REQUEST';
export const LOGIN_AUTH_VERIFY_USER_REQUEST_FAILURE = 'LOGIN_AUTH_VERIFY_USER_REQUEST_FAILURE';
export const LOGIN_AUTH_VERIFY_USER_REQUEST_SUCCESS = 'LOGIN_AUTH_VERIFY_USER_REQUEST_SUCCESS';
export const LOGIN_AUTH_VERIFY_USER_RESET = 'LOGIN_AUTH_VERIFY_USER_RESET';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_REQUEST_FAILURE = 'LOGIN_REQUEST_FAILURE';
export const LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS';
export const PREFERENCES_FETCH = 'PREFERENCES_FETCH';
export const NOTICE_CREATE = 'NOTICE_CREATE';
export const NOTICE_REMOVE = 'NOTICE_REMOVE';
export const OPEN_MODAL = 'OPEN_MODAL';
export const PREFERENCES_FETCH_FAILURE = 'PREFERENCES_FETCH_FAILURE';
export const PREFERENCES_FETCH_SUCCESS = 'PREFERENCES_FETCH_SUCCESS';
export const PREFERENCES_RECEIVE = 'PREFERENCES_RECEIVE';
export const PREFERENCES_REMOVE = 'PREFERENCES_REMOVE';
export const PREFERENCES_SAVE = 'PREFERENCES_SAVE';
export const PREFERENCES_SAVE_FAILURE = 'PREFERENCES_SAVE_FAILURE';
export const PREFERENCES_SAVE_SUCCESS = 'PREFERENCES_SAVE_SUCCESS';
export const PREFERENCES_SET = 'PREFERENCES_SET';
export const ROUTE_SET = 'ROUTE_SET';
export const SECTION_SET = 'SECTION_SET';


// connections
export const CONNECTIONS_RECEIVE = 'CONNECTIONS_RECEIVE';
export const CONNECTIONS_REQUEST = 'CONNECTIONS_REQUEST';
export const CONNECTIONS_REQUEST_SUCCESS = 'CONNECTIONS_REQUEST_SUCCESS';
export const DELETE_CONNECTION_SUCCESS = 'DELETE_CONNECTION_SUCCESS';
export const SAVE_CONNECTION_SUCCESS = 'SAVE_CONNECTION_SUCCESS';
export const CONNECTIONS_REQUEST_FAILURE = 'CONNECTIONS_REQUEST_FAILURE';
export const IMPORT_CONNECTION_SUCCESS = 'IMPORT_CONNECTION_SUCCESS';

// connection types
export const CONNECTION_TYPES_RECEIVE = 'CONNECTION_TYPES_RECEIVE';
export const CONNECTION_TYPES_REQUEST = 'CONNECTION_TYPES_REQUEST';
export const CONNECTION_TYPES_REQUEST_SUCCESS = 'CONNECTION_TYPES_REQUEST_SUCCESS';

// resources
export const RESOURCES_RECEIVE = 'RESOURCES_RECEIVE';
export const RESOURCES_REQUEST = 'RESOURCES_REQUEST';
export const RESOURCES_REQUEST_SUCCESS = 'RESOURCES_REQUEST_SUCCESS';

// sync resource ui
export const INITIALIZE_SYNC_RESOURCE = 'INITIALIZE_SYNC_RESOURCE';

// operations
export const OPERATIONS_REQUEST = 'OPERATIONS_REQUEST';
export const OPERATIONS_REQUEST_SUCCESS = 'OPERATIONS_REQUEST_SUCCESS';
export const OPERATIONS_RECEIVE = 'OPERATIONS_RECEIVE';


// locations
export const LOCATIONS_RECEIVE = 'LOCATIONS_RECEIVE';
export const LOCATIONS_REQUEST = 'LOCATIONS_REQUEST';
export const LOCATIONS_REQUEST_FAILURE = 'LOCATIONS_REQUEST_FAILURE';
export const LOCATIONS_REQUEST_SUCCESS = 'LOCATIONS_REQUEST_SUCCESS';
export const EDIT_LOCATION = 'EDIT_LOCATION';
export const RESET_LOCATION = 'RESET_LOCATION';
export const DELETE_LOCATION_SUCCESS = 'DELETE_LOCATION_SUCCESS';
export const SAVE_LOCATION_SUCCESS = 'SAVE_LOCATION_SUCCESS';

// location groups
export const LOCATION_GROUPS_RECEIVE = 'LOCATION_GROUPS_RECEIVE';
export const LOCATION_GROUPS_REQUEST = 'LOCATION_GROUPS_REQUEST'
export const LOCATION_GROUPS_REQUEST_FAILURE = 'LOCATION_GROUPS_REQUEST_FAILURE'
export const LOCATION_GROUPS_REQUEST_SUCCESS = 'LOCATION_GROUPS_REQUEST_SUCCESS';
export const EDIT_LOCATION_GROUP = 'EDIT_LOCATION_GROUP';
export const RESET_LOCATION_GROUP = 'RESET_LOCATION_GROUP';
export const DELETE_LOCATION_GROUP_SUCCESS = 'DELETE_LOCATION_GROUP_SUCCESS';
export const SAVE_LOCATION_GROUP_SUCCESS = 'SAVE_LOCATION_GROUP_SUCCESS';

// location per website
export const LOCATION_WEBSITES_RECEIVE = 'LOCATION_WEBSITES_RECEIVE';
export const LOCATION_WEBSITES_REQUEST = 'LOCATION_WEBSITES_REQUEST'
export const LOCATION_WEBSITES_REQUEST_FAILURE = 'LOCATION_WEBSITES_REQUEST_FAILURE'
export const LOCATION_WEBSITES_REQUEST_SUCCESS = 'LOCATION_WEBSITES_REQUEST_SUCCESS';
export const EDIT_LOCATION_WEBSITE = 'EDIT_LOCATION_WEBSITE';
export const RESET_LOCATION_WEBSITE = 'RESET_LOCATION_WEBSITE';
export const DELETE_LOCATION_WEBSITE_SUCCESS = 'DELETE_LOCATION_WEBSITE_SUCCESS';
export const SAVE_LOCATION_WEBSITE_SUCCESS = 'SAVE_LOCATION_WEBSITE_SUCCESS';

//ui
export const START_EDITING_LOCATION_GROUP = 'START_EDITING_LOCATION_GROUP';
export const STOP_EDITING_LOCATION_GROUP = 'STOP_EDITING_LOCATION_GROUP';
export const START_EDITING_LOCATION = 'START_EDITING_LOCATION';
export const STOP_EDITING_LOCATION = 'STOP_EDITING_LOCATION';
export const START_SYNC_RESOURCE_CONNECT_MODAL = 'START_SYNC_RESOURCE_CONNECT_MODAL';
export const START_RESOURCE_INFO_MODAL = 'START_RESOURCE_INFO_MODAL';
export const START_RESOURCE_META_DATA_MODAL = 'START_RESOURCE_META_DATA_MODAL';
export const START_OPERATION_DETAILS_MODAL = 'START_OPERATION_DETAILS_MODAL';
export const START_EDITING_LOCATION_WEBSITE = 'START_EDITING_LOCATION_WEBSITE';
export const STOP_EDITING_LOCATION_WEBSITE = 'STOP_EDITING_LOCATION_WEBSITE';
export const START_MAPPING_SALES_TYPES = 'START_MAPPING_SALES_TYPES';
export const STOP_MAPPING_SALES_TYPES = 'STOP_MAPPING_SALES_TYPES';
export const DELETE_MAPPING_SALES_TYPES = 'DELETE_MAPPING_SALES_TYPES';
export const START_ADDING_PAYMENT_TYPES = 'START_ADDING_PAYMENT_TYPES';
export const STOP_ADDING_PAYMENT_TYPES = 'STOP_ADDING_PAYMENT_TYPES';
export const DELETE_PAYMENT_TYPES = 'DELETE_PAYMENT_TYPES';

// connection locations
export const CONNECTION_LOCATIONS_RECEIVE = 'CONNECTION_LOCATIONS_RECEIVE';
export const CONNECTION_LOCATIONS_REQUEST = 'CONNECTION_LOCATIONS_REQUEST';
export const CONNECTION_LOCATIONS_REQUEST_FAILURE = 'CONNECTION_LOCATIONS_REQUEST_FAILURE';
export const CONNECTION_LOCATIONS_REQUEST_SUCCESS = 'CONNECTION_LOCATIONS_REQUEST_SUCCESS';

// terminals
export const TERMINALS_RECEIVE = 'TERMINALS_RECEIVE';
export const TERMINALS_REQUEST = 'TERMINALS_REQUEST';
export const TERMINALS_REQUEST_FAILURE = 'TERMINALS_REQUEST_FAILURE';
export const TERMINALS_REQUEST_SUCCESS = 'TERMINALS_REQUEST_SUCCESS';

// paytypes
export const PAYTYPES_RECEIVE = 'PAYTYPES_RECEIVE';
export const PAYTYPES_REQUEST = 'PAYTYPES_REQUEST';
export const PAYTYPES_REQUEST_FAILURE = 'PAYTYPES_REQUEST_FAILURE';
export const PAYTYPES_REQUEST_SUCCESS = 'PAYTYPES_REQUEST_SUCCESS';

// images
export const IMAGES_RECEIVE = 'IMAGES_RECEIVE';
export const IMAGES_REQUEST = 'IMAGES_REQUEST';
export const IMAGES_REQUEST_FAILURE = 'IMAGES_REQUEST_FAILURE';
export const IMAGES_REQUEST_SUCCESS = 'IMAGES_REQUEST_SUCCESS';

// connection webhooks
export const CONNECTION_WEBHOOKS_RECEIVE = 'CONNECTION_WEBHOOKS_RECEIVE';
export const CONNECTION_WEBHOOKS_REQUEST = 'CONNECTION_WEBHOOKS_REQUEST';
export const CONNECTION_WEBHOOKS_REQUEST_FAILURE = 'CONNECTION_WEBHOOKS_REQUEST_FAILURE';
export const CONNECTION_WEBHOOKS_REQUEST_SUCCESS = 'CONNECTION_WEBHOOKS_REQUEST_SUCCESS';

// connection payment types
export const CONNECTION_PAYMENT_TYPES_RECEIVE = 'CONNECTION_PAYMENT_TYPES_RECEIVE';
export const CONNECTION_PAYMENT_TYPES_REQUEST = 'CONNECTION_PAYMENT_TYPES_REQUEST';
export const CONNECTION_PAYMENT_TYPES_REQUEST_FAILURE = 'CONNECTION_PAYMENT_TYPES_REQUEST_FAILURE';
export const CONNECTION_PAYMENT_TYPES_REQUEST_SUCCESS = 'CONNECTION_PAYMENT_TYPES_REQUEST_SUCCESS';
export const EDIT_CONNECTION_PAYMENT_TYPES = 'EDIT_CONNECTION_PAYMENT_TYPES';
export const RESET_CONNECTION_PAYMENT_TYPES = 'RESET_CONNECTION_PAYMENT_TYPES';
export const DELETE_CONNECTION_PAYMENT_TYPES_SUCCESS = 'DELETE_CONNECTION_PAYMENT_TYPES_SUCCESS';
export const SAVE_CONNECTION_PAYMENT_TYPES_SUCCESS = 'SAVE_CONNECTION_PAYMENT_TYPES_SUCCESS';

// connection retailer sales types
export const CONNECTION_RETAILER_SALES_TYPES_RECEIVE = 'CONNECTION_RETAILER_SALES_TYPES_RECEIVE';
export const CONNECTION_RETAILER_SALES_TYPES_REQUEST = 'CONNECTION_RETAILER_SALES_TYPES_REQUEST';
export const CONNECTION_RETAILER_SALES_TYPES_REQUEST_FAILURE = 'CONNECTION_RETAILER_SALES_TYPES_REQUEST_FAILURE';
export const CONNECTION_RETAILER_SALES_TYPES_REQUEST_SUCCESS = 'CONNECTION_RETAILER_SALES_TYPES_REQUEST_SUCCESS';

// connection retailer pay types
export const CONNECTION_RETAILER_PAY_TYPES_RECEIVE = 'CONNECTION_RETAILER_PAY_TYPES_RECEIVE';
export const CONNECTION_RETAILER_PAY_TYPES_REQUEST = 'CONNECTION_RETAILER_PAY_TYPES_REQUEST';
export const CONNECTION_RETAILER_PAY_TYPES_REQUEST_FAILURE = 'CONNECTION_RETAILER_PAY_TYPES_REQUEST_FAILURE';
export const CONNECTION_RETAILER_PAY_TYPES_REQUEST_SUCCESS = 'CONNECTION_RETAILER_PAY_TYPES_REQUEST_SUCCESS';

// connection sales types
export const CONNECTION_SALES_TYPES_RECEIVE = 'CONNECTION_SALES_TYPES_RECEIVE';
export const CONNECTION_SALES_TYPES_REQUEST = 'CONNECTION_SALES_TYPES_REQUEST';
export const CONNECTION_SALES_TYPES_REQUEST_FAILURE = 'CONNECTION_SALES_TYPES_REQUEST_FAILURE';
export const CONNECTION_SALES_TYPES_REQUEST_SUCCESS = 'CONNECTION_SALES_TYPES_REQUEST_SUCCESS';
export const EDIT_CONNECTION_SALES_TYPES = 'EDIT_CONNECTION_SALES_TYPES';
export const RESET_CONNECTION_SALES_TYPES = 'RESET_CONNECTION_SALES_TYPES';
export const DELETE_CONNECTION_SALES_TYPES_SUCCESS = 'DELETE_CONNECTION_SALES_TYPES_SUCCESS';
export const SAVE_CONNECTION_SALES_TYPES_SUCCESS = 'SAVE_CONNECTION_SALES_TYPES_SUCCESS';